import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import '../CSS/App.css';
import '../CSS/Login.css';
import food from '../media/foodLogin.webp';
import logo from '../media/RezepeLogo.png';

const Login = () => {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [isRegistering, setIsRegistering] = useState(false);
    const [resetPassword, setResetPassword] = useState(false); // State to toggle password reset
    const [error, setError] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        if (location.state?.isRegistering) {
            setIsRegistering(true);
        }
    }, [location]);

    useEffect(() => {
        setError('');
        setSuccessMessage('');
    }, [isRegistering, resetPassword]);

    const handleLogin = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch('https://api.rezepe.com/api/login', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email, password })
            });
            const data = await response.json();
            if (response.ok) {
                localStorage.setItem('authToken', data.token);
                navigate('/home');
            } else {
                setError(data.message || 'Login failed');
            }
        } catch (err) {
            setError('An error occurred. Please try again later.');
        }
    };

    const handleRegister = async (e) => {
        e.preventDefault();
        if (password !== confirmPassword) {
            setError('Passwords do not match');
            return;
        }
        try {
            const response = await fetch('https://api.rezepe.com/api/register', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ name, email, password })
            });
            const data = await response.json();
            if (response.ok) {
                setIsRegistering(false);
                setSuccessMessage(data.message);
            } else {
                setError(data.message || 'Registration failed');
            }
        } catch (err) {
            setError('An error occurred. Please try again later.');
        }
    };

    const handlePasswordReset = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch('https://api.rezepe.com/api/request-password-reset', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email })
            });
            const data = await response.json();
            setError(data.message);
        } catch (err) {
            setError('Error sending reset link. Please try again later.');
        }
    };

    return (
        <div className='login-container'>
            <div className='picture'>
                <img src={food} alt="Food" />
            </div>
            <div className='login-card'>
                {/* Logo Above the Form */}
                <div className="logo-container">
                    <img src={logo} alt="Logo" className="logo" />  {/* Add your logo here */}
                </div>
                <h1>{resetPassword ? 'Reset Your Password' : isRegistering ? 'Register' : 'Login'}</h1>
                {!resetPassword ? (
                    <>
                        <form onSubmit={isRegistering ? handleRegister : handleLogin}>
                            {isRegistering && (
                                <input
                                    type="text"
                                    placeholder="Name"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    required
                                />
                            )}
                            <input
                                type="email"
                                placeholder="Email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                            />
                            <input
                                type="password"
                                placeholder="Password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                            />
                            {isRegistering && (
                                <input
                                    type="password"
                                    placeholder="Confirm Password"
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                    required
                                />
                            )}
                            <button type="submit">{isRegistering ? 'Register' : 'Login'}</button>
                        </form>

                        {/* Messages */}
                        {error && <p className="error">{error}</p>}
                        {successMessage && <p className="success">{successMessage}</p>}

                        {/* Redirect Links */}
                        <div className="extra-options">
                            <p onClick={() => setIsRegistering(!isRegistering)} className="option-link">
                                {isRegistering ? 'Already have an account? Login here' : "Don't have an account? Register here"}
                            </p>
                            <p onClick={() => setResetPassword(true)} className="option-link">
                                Forgot Password?
                            </p>
                        </div>
                    </>
                ) : (
                    // Password reset form
                    <>
                        <form onSubmit={handlePasswordReset}>
                            <input
                                type="email"
                                placeholder="Enter your email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                            />
                            <button type="submit">Send Reset Link</button>
                        </form>
                        {/* Error Message */}
                        {error && <p className="error">{error}</p>}

                        <div className="extra-options">
                            <p onClick={() => setResetPassword(false)} className="option-link">
                                Back to Login
                            </p>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default Login;
